export default "__VITE_ASSET__DXM_EOyG__"